import { AfterContentInit, AfterViewChecked, ChangeDetectorRef, Component, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AppUser } from '@classes/auth/infosUser';
import { Camera } from '@classes/camera/camera';
import { faSearch, faCar, faPlus, faVideo, faCog, faPen, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { CamerasService } from '@services/cameras/cameras.service';
import { DataService } from '@services/data/data.service';
import { RolesService } from '@services/roles/roles.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { SmartparkingCameraInfosLastSyncComponent } from '../smartparking-camera-infos-last-sync/smartparking-camera-infos-last-sync.component';
import { SmartparkingCamerasAddComponent } from '../smartparking-cameras-add/smartparking-cameras-add.component';
import { SmartparkingCamerasConfigComponent } from '../smartparking-cameras-config/smartparking-cameras-config.component';

@Component({
  selector: 'app-smartparking-cameras',
  templateUrl: './smartparking-cameras.component.html',
  styleUrls: ['./smartparking-cameras.component.scss']
})
export class SmartparkingCamerasComponent extends SubscriptionBaseComponent implements OnInit {

  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faCar = faCar;
  faPlus = faPlus;
  faVideo = faVideo;
  faCog = faCog;
  faPen = faPen;

  displayedColumnsAdmin: string[] = ['name', 'ip', 'port', 'syncTime', 'numbCars', 'lastSync', 'config', 'edit'];
  displayedColumns: string[] = ['name', 'numbCars', 'lastSync'];
  dataSource: MatTableDataSource<Camera>;

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  isAdmin: boolean;


  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  show = false;
  userAppSelected: AppUser;


  constructor(
    private cameraService: CamerasService,
    private dialog: MatDialog,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    public router: Router,
    private roleService: RolesService

  ) {
    super();
  }

  ngOnInit(): void {
    this.roleService.getRoleUserApp();
    this.userIsAdmin();
    this.getCameras();
    this.initSub();

  }

  goToSlots(camera: Camera): void {
    const queryparams = { name: camera.name, id: camera.id, ip: camera.ip };
    this.router.navigate(['/smartparking/slots'], { queryParams: queryparams });
  }


  applyFilter(filterValue): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialogInfoCamera(infos: Camera): void {
    const dialogRef = this.dialog.open(SmartparkingCameraInfosLastSyncComponent, {
      data: { lastSync: infos }
    });

  }

  openDialogAddCamera(): void {
    const dialogRef = this.dialog.open(SmartparkingCamerasAddComponent);

    dialogRef.afterClosed().subscribe(() => {
      this.getCameras();
    });
  }

  openConfigCamera(element: Camera): void {
    const dialogRef = this.dialog.open(SmartparkingCamerasConfigComponent, {
      data: { camera: element }
    });
  }

  showElement(): void {
    setTimeout(() => {
      this.show = true;
    }, 150);
  }

  private userIsAdmin(): void {
    this.userAppSelected?.roleUser === 'Admin' ?
      this.dataService.isAdmin.next(true) :
      this.dataService.isAdmin.next(false);
  }

  private getCameras(): void {
    this.cameraService.getCameras().subscribe(res => {

      const cameras = res.filter(c => c.application.ApplicationName === "SmartParking")

      this.dataSource = new MatTableDataSource<Camera>(cameras);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.userAppSelected.subscribe({
          next: userAppSelected => {
            this.userAppSelected = userAppSelected;
            this.userIsAdmin();
            this.cdr.detectChanges();
          },

        })
      )
      .add(
        this.dataService.isAdmin.subscribe(isAdmin => {
          this.isAdmin = isAdmin;
          this.cdr.detectChanges();
        })
      );


  }

}
